import moment, { Moment } from 'moment';

export interface IProfileItemModel {
  /** Checks if empty **/
  isEmpty(): boolean;

  /** Copies beginn, ende and verfuegbar to new object **/
  toEditObject(): IProfileItemModel;

  /** Copies beginn, ende and verfuegbar to new object **/
  fromEditObject(): IProfileItemModel;
}

export abstract class ProfileItemModel implements IProfileItemModel {
  /** Transforms any to date **/
  static anyToDate(dateField: any): Date {
    if (!dateField) {
      return null;
    }
    if (dateField instanceof Date) {
      return dateField;
    }
    if (moment.isMoment(dateField)) {
      return dateField.toDate();
    }
    return new Date(dateField.toString());
  }

  /** Transforms date type to string **/
  static dateTypeToString(dateField: any): string {
    if (!dateField) {
      return null;
    }
    let mom: Moment = null;

    if (dateField instanceof Date) {
      const date = dateField as Date;
      mom = moment(date);
    }

    if (moment.isMoment(dateField)) {
      mom = dateField;
    }

    if (!mom) {
      return null;
    }
    mom.add(mom.utcOffset(), 'm');
    return mom.toISOString(false);
  }

  /** Copies beginn, ende and verfuegbar to new object **/
  fromEditObject<T extends ProfileItemModel>(): T {
    const instance: any = this.newInstance();

    Object.assign(instance, this);
    if (instance['beginn']) {
      instance['beginn'] = ProfileItemModel.dateTypeToString(
        instance['beginn'],
      );
    }
    if (instance['ende']) {
      instance['ende'] = ProfileItemModel.dateTypeToString(instance['ende']);
    }
    if (instance['verfuegbar']) {
      instance['verfuegbar'] = ProfileItemModel.dateTypeToString(
        instance['verfuegbar'],
      );
    }
    return instance as T;
  }

  /** Copies beginn, ende and verfuegbar to new object **/
  toEditObject<T extends ProfileItemModel>(): T {
    const instance: any = this.newInstance();

    Object.assign(instance, this);
    if (instance['beginn']) {
      instance['beginn'] = ProfileItemModel.anyToDate(instance['beginn']);
    }
    if (instance['ende']) {
      instance['ende'] = ProfileItemModel.anyToDate(instance['ende']);
    }
    if (instance['verfuegbar']) {
      instance['verfuegbar'] = ProfileItemModel.anyToDate(
        instance['verfuegbar'],
      );
    }
    return instance as T;
  }

  /** Checks if object is empty, returns false if one property exists **/
  isEmpty(): boolean {
    let isEmpty = true;
    this.getProperties().forEach((key) => {
      if (this[key]) {
        isEmpty = false;
      }
    });
    return isEmpty;
  }

  /** Creates a new object **/
  abstract newInstance<T extends ProfileItemModel>(): T;

  /** Gets all properties **/
  private getProperties(): any[] {
    return Reflect.ownKeys(this);
  }
}
